"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useOn_1 = __importDefault(require("../../hooks/useOn"));
const VerticalTabs_1 = __importDefault(require("../VerticalTabs/VerticalTabs"));
const PrimaryNavigationBar_1 = __importDefault(require("../PrimaryNavigationBar/PrimaryNavigationBar"));
const SecondaryNavigationBar_1 = __importDefault(require("../SecondaryNavigationBar/SecondaryNavigationBar"));
/**
 * Layout is a wrapping component that provides Mosaic's standard app navigation and layout.
 *
 * It incorporates the [PrimaryNavigationBar](/#/Custom%20Components/PrimaryNavigationBar),
 * [SecondaryNavigationBar](/#/Custom%20Components/SecondaryNavigationBar) and
 * [VerticalTabs](/#/Custom%20Components/VerticalTabs) components, as well as additional logic,
 * to achieve the desired layout for Mosaic-powered tools.
 */
const Layout = (_a) => {
    var { primaryNavigationBarLinks, secondaryNavigationBarLinks, sideBarLinks, skipSecondaryNavigationBar, renderPanelPrimaryNavigationBar, isPrimaryNavigationBarPanelConstrained = true, renderPanelSecondaryNavigationBar, isSecondaryNavigationBarPanelConstrained = true, enableFixedHeight = true, enableMaxWidth, enableFixedPosition = false, children, className, 
    // unused props from react router, listed here to exclude from ...otherProps
    history, location, match, staticContext } = _a, otherProps = __rest(_a, ["primaryNavigationBarLinks", "secondaryNavigationBarLinks", "sideBarLinks", "skipSecondaryNavigationBar", "renderPanelPrimaryNavigationBar", "isPrimaryNavigationBarPanelConstrained", "renderPanelSecondaryNavigationBar", "isSecondaryNavigationBarPanelConstrained", "enableFixedHeight", "enableMaxWidth", "enableFixedPosition", "children", "className", "history", "location", "match", "staticContext"]);
    const primaryNavigationBar = react_1.useRef(null);
    const secondaryNavigationBar = react_1.useRef(null);
    if (!((secondaryNavigationBarLinks === null || secondaryNavigationBarLinks === void 0 ? void 0 : secondaryNavigationBarLinks.length) || renderPanelSecondaryNavigationBar)) {
        skipSecondaryNavigationBar = true;
    }
    let containerHeight;
    if (enableFixedHeight) {
        containerHeight = useOn_1.default(window, ['load', 'ready', 'resize'], 0, () => {
            var _a, _b;
            const primaryNavigationBarRect = (_a = primaryNavigationBar === null || primaryNavigationBar === void 0 ? void 0 : primaryNavigationBar.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const secondaryNavigationBarRect = skipSecondaryNavigationBar
                ? { width: 0, height: 0 }
                : (_b = secondaryNavigationBar === null || secondaryNavigationBar === void 0 ? void 0 : secondaryNavigationBar.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            return primaryNavigationBarRect && secondaryNavigationBarRect
                ? window.innerHeight - primaryNavigationBarRect.height - secondaryNavigationBarRect.height
                : window.innerHeight;
        });
    }
    const isShadowOnPrimaryNavigationBar = enableFixedHeight && skipSecondaryNavigationBar;
    const isShadowOnSecondaryNavigationBar = enableFixedHeight && !skipSecondaryNavigationBar;
    return (react_1.default.createElement("div", Object.assign({ className: ['bg-white flex flex-column h-100%', className].join(' ') }, otherProps),
        !!(primaryNavigationBarLinks === null || primaryNavigationBarLinks === void 0 ? void 0 : primaryNavigationBarLinks.length) && (react_1.default.createElement("div", { ref: enableFixedHeight ? primaryNavigationBar : undefined },
            react_1.default.createElement(PrimaryNavigationBar_1.default, { enableFixedPosition: enableFixedPosition, renderPanel: renderPanelPrimaryNavigationBar, isPanelConstrained: isPrimaryNavigationBarPanelConstrained, links: primaryNavigationBarLinks, hasShadow: isShadowOnPrimaryNavigationBar }))),
        !skipSecondaryNavigationBar && (react_1.default.createElement("div", { ref: enableFixedHeight ? secondaryNavigationBar : undefined },
            react_1.default.createElement(SecondaryNavigationBar_1.default, { renderPanel: renderPanelSecondaryNavigationBar, isPanelConstrained: isSecondaryNavigationBarPanelConstrained, links: secondaryNavigationBarLinks, hasShadow: isShadowOnSecondaryNavigationBar }))),
        react_1.default.createElement("div", { className: "flex" },
            react_1.default.createElement("div", { className: "flex-none" },
                react_1.default.createElement(VerticalTabs_1.default, { links: sideBarLinks })),
            react_1.default.createElement("div", { className: 'flex-grow-1 overflow-auto ' + (enableMaxWidth ? 'max-w-13 mh-auto' : ''), style: {
                    height: containerHeight ? containerHeight + 'px' : 'auto',
                } }, children))));
};
exports.default = Layout;
